import { gql } from '@apollo/client';

let widget_option_fields = `
		WidgetId
		Option {
			OptionId
			Name
			Created
			Updated
			OptionPrice{
				OptionPriceId:
				Value
				Currency
			}
		}
		WidgetMetric {
			WidgetMetricId
			Icon
			Order
			WidgetMetricType {
				WidgetMetricTypeId
				Name
			}
			WidgetMetricData {
				Status
				Value
				CompareTo
				Unit
				ChartData
			}
		}
		WidgetText {
			WidgetTextId
			Text
			WidgetTextType {
				Name
			}		   
		}`;

export const ACTIVATE_OPTION = gql`
    mutation activateOption($optionid: Int!, $planid: Int!) {
        activateOption(data: { OptionId: $optionid, PlanId: $planid }) {
            OptionId
            Name
        }
    }
`;

export const DEACTIVATE_OPTION = gql`
    mutation deActivateOption($optionid: Int!, $planid: Int!) {
        deActivateOption(data: { OptionId: $optionid, PlanId: $planid }) {
            OptionId
            Name
        }
    }
`;

export const GET_WIDGET_OPTION = gql(
    `query widgetByOptionId($OptionId: Int!) { widgetByOptionId(data: {OptionId: $OptionId}) {` +
        widget_option_fields +
        `}}`
);
